export enum DrawersEnum {
  DRAWER_EDIT_PROFILE = 'DRAWER_EDIT_PROFILE',
  DRAWER_TRANSACTIONS_BET_DETAILS = 'DRAWER_TRANSACTIONS_BET_DETAILS',
  DRAWER_CONTRIBUTIONS_BET_DETAILS = 'DRAWER_CONTRIBUTIONS_BET_DETAILS',
  DRAWER_SPORTS_RO_BET_DETAILS = 'DRAWER_SPORTS_RO_BET_DETAILS',
}
